module.exports = __webpack_public_path__ + "img/theroom_bed_thumb.609460cd.jpg";